const cenariosMixin = {
  methods: {
    showResume: function (cenario, filtros) {
      function filterLabel(key, filtros, code) {
        if (!code || code == 0) { return false }
        if (typeof filtros != 'object') { return false }

        let filtro = false

        try {
          filtro = filtros.find((f) => {
            if (f.value == code && f.key == key) return true
            return false
          })
        } catch(e) {
          return false
        }

        if (!filtro) { return false }

        return filtro.label
      }

      let arFilters = []
      arFilters.push(filterLabel('local', filtros, cenario.id_local_operacao))
      arFilters.push(filterLabel('estado_origem', filtros, cenario.id_estado_origem))
      arFilters.push(filterLabel('estado_destino', filtros, cenario.id_estado_destino))
      arFilters.push(filterLabel('pais_origem', filtros, cenario.id_pais_origem))
      arFilters.push(filterLabel('pais_destino', filtros, cenario.id_pais_destino))

      let start = '<b>Operação:</b><br> ' + arFilters.filter(f => {
        if (f) { return true }
        return false
      }).join('<br>')
      start = (arFilters.filter(f => f).length > 0) ? start : ''

      // REMETENTE
      arFilters = []
      arFilters.push(filterLabel('regime_tributacao', filtros, cenario.id_remetente_regime))
      arFilters.push(filterLabel('atividade', filtros, cenario.id_remetente_atividade))
      arFilters.push(filterLabel('tipo_atividade', filtros, cenario.id_remetente_tipo_atividade))

      let remetente = '<br><br><b>Remetente:</b><br>' + arFilters.filter(f => {
        if (f) { return true }
        return false
      }).join('<br>')
      remetente = (arFilters.filter(f => f).length > 0) ? remetente : ''

      // DESTINATARIO
      arFilters = []
      arFilters.push(filterLabel('regime_tributacao', filtros, cenario.id_destinatario_regime))
      arFilters.push(filterLabel('atividade', filtros, cenario.id_destinatario_atividade))
      arFilters.push(filterLabel('tipo_atividade', filtros, cenario.id_destinatario_tipo_atividade))

      let destinatario = '<br><br><b>Destinatário:</b><br>' + arFilters.filter(f => {
        if (f) { return true }
        return false
      }).join('<br>')
      destinatario = (arFilters.filter(f => f).length > 0) ? destinatario : ''

      // PRODUTO
      arFilters = []
      arFilters.push(filterLabel('origem_mercadoria', filtros, cenario.id_origem))
      arFilters.push(filterLabel('destinacao', filtros, cenario.id_destinacao))

      let produto = '<br><br><b>Mercadoria:</b><br>' + arFilters.filter(f => {
        if (f) { return true }
        return false
      }).join('<br>')
      produto = (arFilters.filter(f => f).length > 0) ? produto : ''

      return start + remetente + destinatario + produto
    },
    resetValidacao: function () {
      return {
        selected_pais_origem: {
          status: false,
          touched: false
        },
        selected_pais_destino: {
          status: false,
          touched: false
        },
        selected_estado_destino: {
          status: false,
          touched: false
        },
        selected_cnae_remetente: {
          status: false,
          touched: false
        },
        selected_atividade: {
          status: false,
          touched: false
        },
        selected_regime_tributacao_remetente: {
          status: false,
          touched: false
        },
        selected_cnae: {
          status: false,
          touched: false
        },
        selected_regime_tributacao_destinatario: {
          status: false,
          touched: false
        },
        selected_origem_mercadoria: {
          status: false,
          touched: false
        },
        selected_local: {
          status: false,
          touched: false
        },
        selected_estado_origem: {
          status: false,
          touched: false
        },
        selected_atividade_destinatario: {
          status: false,
          touched: false
        },
        selected_tipo_atividade_destinatario: {
          status: false,
          touched: false
        },
				selected_destinacao: {
				  status: false,
				  touched: false
				},
      }
    },
    showResumeFields: function (cenario, filtros) {
      function filterLabel(key, filtros, code) {
        if (!code || code == 0) { return null }
        if (typeof filtros != 'object') { return null }

        let filtro = false

        try {
          filtro = filtros.find((f) => {
            if (f.value == code && f.key == key) return true
            return false
          })
        } catch(e) {
          return null
        }

        if (!filtro) { return null }

        return filtro.label
      }

      let obFilters = {}
      obFilters.nome_cenario = cenario.nomeCenario
      obFilters.local = filterLabel('local', filtros, cenario.id_local_operacao)
      obFilters.estado_origem = filterLabel('estado_origem', filtros, cenario.id_estado_origem)
      obFilters.estado_destino = filterLabel('estado_destino', filtros, cenario.id_estado_destino)
      obFilters.pais_origem = filterLabel('pais_origem', filtros, cenario.id_pais_origem)
      obFilters.pais_destino = filterLabel('pais_destino', filtros, cenario.id_pais_destino)

      // REMETENTE
      obFilters.id_remetente_regime = filterLabel('regime_tributacao', filtros, cenario.id_remetente_regime)
      obFilters.id_remetente_atividade = filterLabel('atividade', filtros, cenario.id_remetente_atividade)
      obFilters.id_remetente_tipo_atividade = filterLabel('tipo_atividade', filtros, cenario.id_remetente_tipo_atividade)
      obFilters.cnae_remetente = cenario.cnae_remetente
      obFilters.cnpj_remetente = cenario.cnpjRemetente

      // DESTINATARIO
      obFilters.id_destinatario_regime = filterLabel('regime_tributacao', filtros, cenario.id_destinatario_regime)
      obFilters.id_destinatario_atividade = filterLabel('atividade', filtros, cenario.id_destinatario_atividade)
      obFilters.id_destinatario_tipo_atividade = filterLabel('tipo_atividade', filtros, cenario.id_destinatario_tipo_atividade)
      obFilters.cnae_destinatario = cenario.cnae_destinatario
      obFilters.cnpj_destinatario = cenario.cnpjDestinatario

      // PRODUTO
      obFilters.id_origem = filterLabel('origem_mercadoria', filtros, cenario.id_origem)
      obFilters.id_destinacao = filterLabel('destinacao', filtros, cenario.id_destinacao)

      // SIMPLES NACIONAL
      obFilters.sn_rba = cenario.sn_rba
      obFilters.sn_rbt12 = cenario.sn_rbt12
      obFilters.sn_rm = cenario.sn_rm

      return obFilters
    },
    getParent: function (this_parent) {
			/* o cenário pode estar dentro do componente do slide, por isso pego o primeiro parent depois do carousell */
      let parent = this_parent;
			let arClassesSlide = [
        'VueCarousel-slide', 
        'VueCarousel', 
        'VueCarousel-slide VueCarousel-slide-active VueCarousel-slide-center', 
        'VueCarousel-slide VueCarousel-slide-adjustableHeight'
      ];

			while (arClassesSlide.some(c => {
					return c == parent.$el.className
				})) {
				parent = parent.$parent.$parent;
			}

			return parent;
		},
  },
}

export default cenariosMixin
